module.exports = __webpack_public_path__ + "static/media/REACT_LOGO_1.73af420c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/REACT_LOGO_1.svg
// module id = 340
// module chunks = 0